"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpasLoader = void 0;
var _logger = require("./logger");
var _spas = require("./spas");
var _jsxRuntime = require("react/jsx-runtime");
const logger = _logger.mainLogger.createChild('SpasLoader');

/**
 * Renders blob storage SPA loaders with current context configuration inside ASMS instance page.
 * Allows rendering of select SPAs via `spas` prop (renders none by default).
 */
const SpasLoader = ({
  environment,
  spas = {}
}) => {
  const names = Object.keys(spas);
  return names.map(name => {
    const {
      enabled = false,
      props
    } = spas[name] ?? {};
    if (enabled) {
      const Spa = _spas.spas[name];
      if (typeof Spa === 'undefined') {
        logger.warn(`You're trying to load an unknown SPA "${name}".`);
        return undefined;
      }
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(Spa, {
        environment: environment,
        ...props
      }, name);
    }
    return undefined;
  });
};
exports.SpasLoader = SpasLoader;
